import { render, staticRenderFns } from "./CertificateMappingTable.vue?vue&type=template&id=57fb8473"
import script from "./CertificateMappingTable.vue?vue&type=script&lang=js"
export * from "./CertificateMappingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports